import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Tabular-numeral rupee amount. `v` is the pre-formatted amount (no ₹). */
export function Money({
  v,
  className,
  strong,
}: {
  v: ReactNode;
  className?: string;
  strong?: boolean;
}) {
  return <span className={cn('wb-mono wb-tnum', strong && 'wb-strong', className)}>₹{v}</span>;
}
